define('models/LiveModel',['require','lib/backbone/Backbone.PodioModel'],function(require) {

  var PodioModel = require('lib/backbone/Backbone.PodioModel');

  return PodioModel.extend({
    idAttribute: 'live_id',
    useDirectAPIAccess: true,

    urlRootAPI: function() {
      return '/live';
    },

    urlAPI: function() {
      var path;
      if (this.isNew()) {
        path = '/{0}/{1}'.format(this.get('ref_type'), this.get('ref_id'));
      } else {
        path = '/{0}'.format(this.get('live_id'));
      }
      return this.urlRootAPI() + path;
    },

    accept: function() {
      return this.request('post', this.urlAPI() + '/accept');
    },

    reject: function() {
      return this.request('post', this.urlAPI() + '/decline');
    }
  });

});

